// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CONTESTS_ADD_REPLY = "Zapoj sa do s\u00fa\u0165a\u017ee...";
export const FORUM_ADD_REPLY = "Tu za\u010dni p\u00edsa\u0165 odpove\u010f...";
export const FORUM_COMMENT_EDIT_TEXT = "Odpove\u010f";
export const FORUM_COMMENT_FORM_EMPTY_MESSAGE_CANNOT_BE_SENT = "Pr\u00e1zdnu spr\u00e1vu nem\u00f4\u017ee\u0161 odosla\u0165";
export const SEND_AS_ADMIN = "oznam MK";
export const SEND_COMMENT_FORUM = "Odo\u0161li";
